import { useState } from "react";

// Defines a custom hook to store the login token in the session storage
export default function useToken() {
    // Retrieve token from session storage
    const getToken = () => {
        // const tokenString = sessionStorage.getItem('token') as string;
        // const userToken = JSON.parse(tokenString);
        return document.cookie;
    }

    const [token, setToken] = useState(getToken());

    // Save token to session storage and set it as active state
    const saveToken = (userToken: any) => {
        if (userToken) {
            //SET USER SESSION ID TO CONTROL LOGIN 
            document.cookie = "token=" + userToken.session_id;            
            //SET USER PERMISSIONS 
            sessionStorage.setItem('access-type', userToken?.access_type ?? "");
            setToken(document.cookie);
        }
        else {
            throw new Error('ERROR - Unknown user');
        }
    }

    return {
        setToken: saveToken,
        token
    }
}